import { request } from './client';
import type {
  AiAnswer,
  AiConversation,
  AiHistory,
  AiTurn,
} from '../types';

/** The AI assistant. */
export const aiApi = {
  /**
   * Ask the assistant. The whole conversation goes up each time — the panel is
   * what holds it — and the model is reached from the server, never from here:
   * the API key belongs nowhere near a bundle the browser can read.
   */
  chat: (wellId: number, messages: AiTurn[], conversationId?: number) =>
    request<AiAnswer>(`/wells/${wellId}/ai/chat`, {
      method: 'POST',
      body: JSON.stringify({ messages, conversationId: conversationId ?? 0 }),
    }),

  /** Your own threads — or everyone's, when the server says you may. */
  history: (limit = 50) => request<AiHistory>(`/ai/conversations?limit=${limit}`),

  thread: (id: number) => request<AiConversation>(`/ai/conversations/${id}`),
};
